import { Button, Card, Col, Row } from 'react-bootstrap';
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import logoImg from '../../assets/images/logo-light.png';
import logofo from '../../assets/images/fibra.png';
// import QRCodeGenerator from './QrCodeGenerator';

const NominaPrint = ({ data, user }) => {
    let { dia, extra, faltas, monto, caduca, fecha } = data;
    let { inicio_labores, fin_labores, vale } = user;
    let periodo = moment(data.inicio).format('LL') + ' al ' + moment(data.fin).format('LL');
    const [totalF, setTotal] = useState(0);
    const contentRef = useRef();
    useEffect(() => {
        let diasServicio = 0;

        const inicioLaboresMoment = moment(inicio_labores, 'YYYY-MM-DD'); // Parseando la fecha correctamente
        const finLaboresMoment = moment(fin_labores, 'YYYY-MM-DD'); // Parseando la fecha correctamente

        if (!inicioLaboresMoment.isValid()) {
            console.error('Fecha de inicio de labores no es válida');
        } else {
            diasServicio = moment(finLaboresMoment).diff(inicioLaboresMoment, 'days');
            diasServicio += 1;
        }
        let total;
        if (diasServicio >= 15) {
            total = Math.round(dia * 15);
        } else {
            total = Math.round(dia * diasServicio);
        }
        if (extra > 0) {
            total += extra * dia * 2;
        }
        if (faltas > 0) {
            let totalFaltas = dia * 1.16 * faltas;
            total -= totalFaltas;
        }
        if (data.total > 0) {
            setTotal(data.total);
        } else {
            setTotal(total);
        }
    }, [data]);
    const handleGeneratePdf = () => {
        const element = contentRef.current;

        const opt = {
            filename: 'documento.pdf', // Nombre del archivo PDF
            margin: [10, 10, 10, 10], // [top, left, bottom, right]
            html2canvas: {
                useCORS: true, // Habilitar el uso de CORS (opcional, necesario si hay problemas con las imágenes)
                scale: 2,
            },
            jsPDF: {
                orientation: 'portrait',
            },
        };

        const loadImages = () => {
            const images = element.getElementsByTagName('img');
            const totalImages = images.length;
            let imagesLoaded = 0;

            return new Promise((resolve, reject) => {
                if (totalImages === 0) {
                    resolve();
                } else {
                    for (let i = 0; i < totalImages; i++) {
                        images[i].addEventListener('load', () => {
                            imagesLoaded++;
                            if (imagesLoaded === totalImages) {
                                resolve();
                            }
                        });
                        images[i].addEventListener('error', () => {
                            reject(new Error('Error loading images'));
                        });
                        // En caso de que la imagen ya esté cargada en caché
                        if (images[i].complete) {
                            imagesLoaded++;
                            if (imagesLoaded === totalImages) {
                                resolve();
                            }
                        }
                    }
                }
            });
        };

        loadImages()
            .then(() => {
                html2pdf()
                    .from(element)
                    .set(opt)
                    .output('blob')
                    .then((pdfBlob) => {
                        // Crear un objeto URL para el PDF
                        const pdfUrl = URL.createObjectURL(pdfBlob);

                        // Abrir el PDF en una nueva pestaña para imprimir
                        const pdfWindow = window.open(pdfUrl);
                        pdfWindow.addEventListener('load', () => {
                            pdfWindow.print();
                        });
                    });
            })
            .catch((error) => {
                console.error('Error generating PDF:', error);
            });
    };

    return (
        <Col>
            <Card>
                <div className="d-print-none mt-4">
                    <div className="text-end">
                        <button className="btn btn-primary me-1" onClick={handleGeneratePdf}>
                            <i className="mdi mdi-printer"></i>Imprimir
                        </button>
                    </div>
                </div>
                <Card.Body>
                    <div id="print" className="print-content" ref={contentRef}>
                        <div className="clearfix">
                            <div className="float-start mb-3">
                                <img src={logoImg} alt="logo" height="25" crossOrigin="anonymous" />
                            </div>
                            <div className="float-end">
                                <h4 className="m-0 d-print-none">Nomina</h4>
                            </div>
                        </div>

                        <Row>
                            <Col>
                                <div className="mt-3 text-center">
                                    <p className="font-13">
                                        <strong className="text-uppercase">
                                            DESGLOSE DE SUELDO DEL PERIODO: {periodo}
                                        </strong>
                                    </p>
                                </div>
                            </Col>
                        </Row>

                        <Row className="mt-1">
                            <Col sm={4}>
                                <h5>Empleado: {user.nombre}</h5>
                            </Col>
                            <Col sm={4} lg={{ span: 4, offset: 4 }}>
                                <h5>Sueldo por dia: ${dia}</h5>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <div>
                                    <table className="table  table-bordered border-secondary table-responsive mt-4">
                                        <thead className="table-secondary">
                                            <tr>
                                                <th>Sueldo Efectivo</th>
                                                <th>Sueldo Transferencia</th>
                                                <th>Sueldo quincenal</th>
                                                <th>Faltas</th>
                                                <th>Dia pagado no laborable</th>
                                                <th>Descuento del dia</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>${(totalF - data.transferencia).toFixed(2)}</td>
                                                <td>${data.transferencia}</td>
                                                <td>${Math.round(data.dia * 15).toFixed(2)}</td>
                                                <td>{data.faltas}</td>
                                                <td>
                                                    Dias: {data.extra} ---${data.extra * data.dia * 2}
                                                </td>
                                                <td>{(data.dia * 1.16 * data.faltas).toFixed(2)}</td>
                                            </tr>
                                            <tr className="fs-5">
                                                <td
                                                    colSpan="5 "
                                                    className="text-end border border-secondary  fw-bolder text-bg-warning table-light">
                                                    TOTAL
                                                </td>

                                                <td className="text-end fw-bolder border border-secondary">
                                                    ${Math.round(totalF).toFixed(2)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div className="text-center">
                                    <hr
                                        style={{
                                            width: '50%',
                                            height: '5px',
                                            margin: '60px auto 10px auto',
                                            color: 'black',
                                        }}
                                    />
                                    <h5>Firma del empleado</h5>
                                </div>
                            </Col>
                        </Row>
                        {/* Sección del Vale de Despensa ajustada */}
                        {vale && data.monto != null && (
                            <Row
                                className="p-3 border border-primary rounded-3 shadow mt-4"
                                style={{
                                    background:
                                        'radial-gradient(circle, rgba(255,255,255,1) 70%, rgba(193,214,233,1) 100%)',
                                }}>
                                {/* Encabezado con logo y título */}
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <img src={logoImg} alt="logo" height="45" crossOrigin="anonymous" />
                                    <div className="">
                                        <h5 className="text-primary fw-bold mb-0">VALE DE DESPENSA</h5>
                                        {/* <div className="d-flex justify-content-end mt-3">
                                            <h4 className="fw-bold text-success ">
                                                Vale por:
                                                <span
                                                    className="text-white bg-success rounded-pill px-2 py-1 ms-1"
                                                    style={{
                                                        fontSize: '1rem',
                                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                                    }}>
                                                    <i className="mdi mdi-cash-check me-1"></i>${monto}.00
                                                </span>
                                            </h4>
                                        </div> */}
                                    </div>
                                </div>

                                {/* Información del vale */}
                                <Row className="">
                                    <Col xs={8}>
                                        <p className=" mb-1">
                                            <i className="bi bi-card-text me-2"></i>
                                            <strong>Folio:</strong> <span className="text-danger">{data?.folio}</span>
                                        </p>
                                        <p className=" mb-1">
                                            <i className="bi bi-code-slash me-2"></i>
                                            <strong>Código:</strong> <span className="text-danger">{data?.codigo}</span>
                                        </p>
                                        <p className=" mb-1">
                                            <i className="bi bi-person-fill me-2"></i>
                                            <strong>A la orden de:</strong> {user.nombre}
                                        </p>
                                        <p className=" mb-1">
                                            <i className="bi bi-calendar-event me-2"></i>
                                            <strong>Fecha:</strong> {moment(fecha).format('YYYY-MM-DD')}
                                        </p>
                                        <p className=" mb-0">
                                            <i className="bi bi-calendar-check me-2"></i>
                                            <strong>Válido hasta:</strong> {caduca}
                                        </p>
                                    </Col>
                                    <Col xs={4}>
                                    <div className="d-flex justify-content-end">
                                            <h4 className="fw-bold text-success ">
                                                Vale por:
                                                <span
                                                    className="text-white bg-success rounded-pill px-2 py-1 ms-1"
                                                    style={{
                                                        fontSize: '1rem',
                                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                                    }}>
                                                    <i className="mdi mdi-cash-check me-1"></i>${monto}.00
                                                </span>
                                            </h4>
                                        </div>
                                   
                                    </Col>
                                </Row>

                                {/* Pie de firma */}
                                <Row>
                                    <Col></Col>
                                    <Col>
                                        {' '}
                                        <div className="text-center mt-3">
                                            <hr
                                                style={{
                                                    width: '100%',
                                                    height: '1px',
                                                    margin: '10px auto',
                                                    backgroundColor: '#000',
                                                }}
                                            />
                                            <h6 className="fw-bold mb-1">AUTORIZA</h6>
                                            <p className=" mb-0 small">RUNTIME WIFI TELECOMUNICACIONES</p>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="d-flex justify-content-end">
                                            <img src={logofo} alt="logo" height="60" crossOrigin="anonymous" />
                                        </div>
                                    </Col>
                                </Row>
                            </Row>
                        )}
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default NominaPrint;
